<template>
    <div class="referral">
        <!-- <img class="mask-group-icon" src="@/assets/banners/masker.svg" /> -->
        <!-- <div class="illustration-parent">
            <div class="illustration">
            </div>
        </div> -->
        <img src="@/assets/banners/refferal-banner.svg" style="width: 100%;" />
        <div class="referral-inner">
            <span class="refer-and-earn">Refer and earn Up to <b>500</b> AED!</span>
            <div class="share-your-referral-code-with-parent">
                <ul class="share-your-referral-code-with">
                    <li>Share your referral code with friends.</li>
                    <li>Earn 50 AED when they reach 5,000 AED.</li>
                    <li>Check details in Refer and Earn on your profile.</li>
                </ul>
            </div>
        </div>
        <div style="width: 100%; display: flex; flex-direction: row-reverse; justify-content: space-around; padding: 16px;">
            <div class="button">
                <b class="label">Sign Up Now</b>
                <img class="arrow-right-icon" alt="" src="@/assets/icons/arrow.svg" />
            </div>
            <div class="button1">
                <b>Learn more</b>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ReferralBanner"
}
</script>

<style scoped>
.b {
    position: relative;
    line-height: 5.446rem;
}

.aed {
    position: relative;
    font-size: 2.971rem;
    line-height: 5.446rem;
    font-weight: 600;
}

.parent {
    position: absolute;
    top: 1.5rem;
    left: -1rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 0.987rem;
    opacity: 0.2;
}

.illustration {
    position: absolute;
    top: 0rem;
    left: calc(50% - 106px);
    width: 13.188rem;
    height: 15.375rem;
}

.refer-and-earn {
    font-weight: 500;
    display: flex;
    text-align: center;
    line-height: 3.198rem;
    display: inline-block;
    width: 19.625rem;
    font-size: 2.5rem;
}

.span {
    font-size: 2.619rem;
}

.b1 {
    font-size: 2.75rem;
}

ul {
    list-style-type: disc;
    /* Or 'circle', 'square', etc. */
    padding-left: 20px;
    /* Add padding to position the dot correctly */
}

.illustration-parent {
    position: absolute;
    top: 6.14rem;
    left: calc(50% - 157px);
    width: 19.625rem;
    height: 22.938rem;
    text-align: center;
    font-size: 4.456rem;
}

.share-your-referral-code-with {
    margin: 0;
    font-size: inherit;
    padding-left: 1.312rem;
}

.share-your-referral-container {
    width: 18.875rem;
    position: relative;
    line-height: 1.125rem;
    font-weight: 500;
    display: inline-block;
}

.share-your-referral-code-with-parent {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 20rem;
    gap: 0.5rem;
}

.referral-inner {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    margin-top: 1.5rem;
}

.label {
    position: relative;
    line-height: 1.25rem;
}

.arrow-right-icon {
    width: 1.5rem;
    position: relative;
    height: 1.5rem;
    overflow: hidden;
    flex-shrink: 0;
}

.button {
    box-shadow: 0px 2px 5.2px rgba(41, 92, 167, 0.24);
    border-radius: 8px;
    background-color: #0fa964;
    width: 10.938rem;
    height: 3.5rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0.875rem 1.25rem;
    box-sizing: border-box;
    gap: 0.75rem;
}

.button1 {
    filter: drop-shadow(0px 2px 5.2px rgba(41, 92, 167, 0.24));
    border-radius: 8px;
    border: 1px solid #fff;
    box-sizing: border-box;
    width: 11rem;
    height: 3.5rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0.875rem 1.75rem;
}

.referral {
    width: 100%;
    background: linear-gradient(180deg, rgba(3, 13, 40, 0.2) 50%, rgba(3, 6, 24, 0)), linear-gradient(180deg, #2065cb, #7ab0ff);
    height: 47rem;
    overflow: hidden;
    text-align: left;
    font-size: 1rem;
    color: #fff;
}
</style>